import { Avatar } from '@radix-ui/themes';
const UserAvatar = ({ user, size = '2', radius = 'large' }) => {
  const PUBLIC_URL = import.meta.env.VITE_PUBLIC_URL
  if (!user) return null;

  return (
    <Avatar
    variant="solid"
      size={size}
      src={`${PUBLIC_URL}/storage/${user.profile_picture}`}
      fallback={user.firstname?.[0]}
      radius={radius}
      style={{zIndex:2}}
    />
  );
};

export default UserAvatar; 